import React from 'react';
import PropTypes from 'prop-types';
import { fixedFloatAndCommas } from '../../utils/conversion';

const pickListConfig = [
  {
    id: 1,
    label: 'business_name',
    title: 'Business Name',
  },
  {
    id: 2,
    label: 'brand',
    title: 'Brand',
  },
  {
    id: 3,
    label: 'sku_id',
    title: 'SKU Id',
    className: 'print_display_none',
  },
  {
    id: 4,
    label: 'sku_name',
    title: 'SKU Name',
  },
  {
    id: 5,
    label: 'quantity',
    title: 'Quantity(pcs)',
    className:'text-right',
  },
  {
    id: 6,
    label: 'amount',
    title: 'Amount',
    className:'text-right',
  },
];

const pickListTableBody = ({ dataList = [],remainingLines=[] }) => {
  return (
    <tbody>
      {dataList.map((data) => (
        <tr>
          <td className='left-align business'>{data.businessName}</td>
          <td className='left-align brand'>{data.brand}</td>
          <td className='left-align print_display_none'>{data.skuId}</td>
          <td className='left-align sku'>{data.skuName}</td>
          <td className='right-align qty'>{data.qtyPcs}</td>
          <td className='right-align total'>{fixedFloatAndCommas(data.total)}</td>
        </tr>
      ))}
      {remainingLines && remainingLines.length
        ? remainingLines.map((i) => (
          <tr className='blank-tr'>
            <td></td>
            <td colSpan ='11' className=''></td>
          </tr>
        ))
        : null}
    </tbody>
  );
};

pickListTableBody.propTypes = { data: PropTypes.object.isRequired };
const title = 'Pick List';
const lengthyAttributes = ['skuName','businessName','brand'];
const printEnums = {
  withoutFooterLimit: 55,
  withFooterLimit: 55,
  skuName: 54,
  brand: 23,
  businessName: 23,
  lengthyAttributes,
};

const config = {
  title,
  header: pickListConfig,
  getTableBody: pickListTableBody,
  printEnums,
  uniqueIdGetter: (i) => `${i?.skuId}_${i?.businessId}_${i?.qtyPcs}`,
};

export default config;
